import { castDraft, immerable, produce } from 'immer';

import dayjs from '../../../core/configs/dayjs';
import {
	ConsumeStatus,
	DatablockColumn,
} from '../../domain/subscription.types';

interface IConsumedProjectItemEntity {
	id: number;
	projectUuid: string;
	projectLabel: string;
	targetProjectVersions: Array<string>;
	active: boolean;
	status: ConsumeStatus;
	profileUuid: string;
	profileLabel: string;
	columnProfileCount: number;
	profileColumns: Array<DatablockColumn>;
	sourceProjectVersion: string;
	startDate: dayjs.Dayjs | null;
	isInSync: boolean;
	isInCurrentVersion: boolean;
}

const entityDefaults: IConsumedProjectItemEntity = {
	id: -1,
	projectUuid: '-1',
	projectLabel: '',
	targetProjectVersions: [],
	active: false,
	status: ConsumeStatus.Unknown,
	profileUuid: '',
	profileLabel: '',
	columnProfileCount: 0,
	profileColumns: [],
	sourceProjectVersion: '',
	startDate: null,
	isInSync: false,
	isInCurrentVersion: false,
};

export class ConsumedProjectItemEntity implements IConsumedProjectItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public projectUuid = entityDefaults.projectUuid;
	public projectLabel = entityDefaults.projectLabel;
	public targetProjectVersions = entityDefaults.targetProjectVersions;
	public active = entityDefaults.active;
	public status = entityDefaults.status;
	public profileUuid = entityDefaults.profileUuid;
	public profileLabel = entityDefaults.profileLabel;
	public columnProfileCount = entityDefaults.columnProfileCount;
	public profileColumns = entityDefaults.profileColumns;
	public sourceProjectVersion = entityDefaults.sourceProjectVersion;
	public startDate = entityDefaults.startDate;
	public isInSync = entityDefaults.isInSync;
	public isInCurrentVersion = entityDefaults.isInCurrentVersion;

	public static build(
		params: Partial<IConsumedProjectItemEntity> = {}
	): ConsumedProjectItemEntity {
		const instance = new ConsumedProjectItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.projectUuid = params.projectUuid ?? entityDefaults.projectUuid;
		instance.projectLabel = params.projectLabel ?? entityDefaults.projectLabel;
		instance.targetProjectVersions =
			params.targetProjectVersions ?? entityDefaults.targetProjectVersions;
		instance.active = params.active ?? entityDefaults.active;
		instance.status = params.status ?? entityDefaults.status;
		instance.profileUuid = params.profileUuid ?? entityDefaults.profileUuid;
		instance.profileLabel = params.profileLabel ?? entityDefaults.profileLabel;
		instance.columnProfileCount =
			params.columnProfileCount ?? entityDefaults.columnProfileCount;
		instance.profileColumns =
			params.profileColumns ?? entityDefaults.profileColumns;
		instance.sourceProjectVersion =
			params.sourceProjectVersion ?? entityDefaults.sourceProjectVersion;
		instance.startDate = params.startDate ?? entityDefaults.startDate;
		instance.isInSync = params.isInSync ?? entityDefaults.isInSync;
		instance.isInCurrentVersion =
			params.isInCurrentVersion ?? entityDefaults.isInCurrentVersion;

		return instance;
	}

	public setProfileColumns(
		columns: Array<DatablockColumn>
	): ConsumedProjectItemEntity {
		return produce(this, (draft) => {
			draft.profileColumns = castDraft(columns);
		});
	}
}
